/**
 * ZEN ERP — Mobil Bayi Uygulamasından Gelen Yeni Siparişler
 * Diğer siparişlerden görsel olarak ayrışan bildirim bandı.
 */
import React from "react";
import { Smartphone, Check, Pencil } from "lucide-react";
import { fmt, ono } from "../../appUtils";
import api from "../../api";
import { toast } from "sonner";

export function DashboardMobileOrders({ orders, tr, setEditingOrder, onReviewed }) {
  if (!orders || orders.length === 0) return null;

  const markReviewed = async (o) => {
    try {
      await api.patch(`/orders/${o.id}/mark-reviewed`);
      toast.success(`${o.orderNo || o.id} onaylandı`);
      onReviewed?.(o.id);
    } catch (e) { toast.error("İşlem başarısız"); }
  };

  return (
    <div
      data-testid="dashboard-mobile-orders-banner"
      className="rounded-2xl border-2 border-dashed border-violet-400 bg-violet-50 dark:bg-violet-950/30 dark:border-violet-500/60 p-4 space-y-3 zen-anim-pulse-glow"
    >
      <h3 className="text-sm font-extrabold tracking-tight text-violet-700 dark:text-violet-300 flex items-center gap-2">
        <Smartphone className="w-4 h-4" />
        {tr("Yeni Bayi Siparişi (Mobil)")} ({orders.length})
      </h3>
      <div className="space-y-2">
        {orders.map(o => (
          <div key={o.id} data-testid={`mobile-order-card-${o.id}`} className="rounded-xl bg-white dark:bg-[#171130] py-2.5 px-3 flex items-center gap-3 text-sm border border-violet-300 dark:border-violet-500/40 shadow-sm">
            <span className="w-2 h-2 rounded-full bg-violet-500 shrink-0 animate-pulse" />
            <div className="flex-1 min-w-0">
              <span className="zen-mono text-xs font-bold text-violet-600 dark:text-violet-300 mr-2">{ono(o)}</span>
              <span className="text-slate-500 text-xs">{o.customerName}</span>
              <div className="text-[11px] text-slate-500 truncate">{o.items?.[0]?.product || "—"}{o.items?.length > 1 && ` +${o.items.length - 1}`}</div>
            </div>
            <div className="zen-mono font-bold">{fmt(o.total, o.currency)}</div>
            <button data-testid={`btn-mobile-order-edit-${o.id}`} onClick={() => setEditingOrder(o)} className="zen-btn-ghost !py-1.5 !px-2">
              <Pencil className="w-3.5 h-3.5" />
            </button>
            <button data-testid={`btn-mobile-order-reviewed-${o.id}`} onClick={() => markReviewed(o)} className="zen-btn-primary !py-1.5 !px-3 !text-xs !bg-violet-600 hover:!bg-violet-700">
              <Check className="w-3.5 h-3.5" /> {tr("Gördüm")}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
